import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { logout } from 'state/modules/auth';
import { connect } from 'react-redux';
import { Header } from 'components/HeroSemantic';
import { Logo, UserStatus } from 'components';
import './Header.css';

class HeaderWrapper extends PureComponent {
  static propTypes = {
    logout: PropTypes.func.isRequired,
    user: PropTypes.object,
    tenant: PropTypes.object.isRequired,
  };

  handleLogout() {
    this.props.logout();
  }

  render() {
    const { user, tenant: { id, theme: { maxWidth } } } = this.props;
    const outerStyle = {
      background: 'var(--owner-header-bg)',
      width: '100%',
    };
    const innerStyle = {
      alignItems: 'center',
      display: 'flex',
      gap: '28px',
      margin: '0 auto',
      maxWidth: `${maxWidth}px`,
      minHeight: '120px',
      padding: '0 32px',
      width: '100%',
    };
    const titleStyle = {
      flex: '1 1 auto',
      margin: 0,
      fontSize: '28px',
      lineHeight: 1.2,
    };
    const statusStyle = {
      alignItems: 'center',
      display: 'flex',
      flex: '0 0 auto',
      justifyContent: 'flex-end',
      minWidth: '320px',
    };

    // Ki Niseko Header
    if (id === 'kiniseko') {
      return (
        <div style={outerStyle}>
          <div style={innerStyle}>
            <Logo tenant={id} inverted style={{ maxHeight: '100px', padding: '5px' }} />
            <Header as="h2" style={titleStyle}>
              <FormattedMessage id="header.title" />
            </Header>
            <div style={statusStyle}>
              { user && <UserStatus name={user.username} logout={() => this.handleLogout()} /> }
            </div>
          </div>
        </div>
      );
    }
    // Niseko Central Header
    if (id === 'nisekocentral') {
      return (
        <div style={outerStyle}>
          <div style={innerStyle}>
            <Logo tenant={id} inverted style={{ maxWidth: '200px', padding: '20px' }} />
            <Header as="h2" inverted style={titleStyle}>
              <FormattedMessage id="header.title" />
            </Header>
            <div style={statusStyle}>
              { user && <UserStatus inverted name={user.username} logout={() => this.handleLogout()} /> }
            </div>
          </div>
        </div>
      );
    }
    // Skye Header
    if (id === 'skye') {
      return (
        <div style={outerStyle}>
          <div className="bar" />
          <div style={innerStyle}>
            <Logo
              tenant={id}
              inverted
              src="/logo_light.png"
              darkSrc="/logo.png"
              style={{ maxWidth: '200px', padding: '40px' }}
            />
            <Header as="h2" style={titleStyle}>
              <FormattedMessage id="header.title" />
            </Header>
            <div style={statusStyle}>
              { user && <UserStatus name={user.username} logout={() => this.handleLogout()} /> }
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}

export default connect(state => ({ user: state.auth.user, tenant: state.tenant }), { logout })(HeaderWrapper);
